module.exports = __webpack_public_path__ + "img/qrcode.8aa76f44.png";